import { BackgroundLevel0, Overlay2 } from '@tanium/react-theme-definition';

export const StickyFooterBackground = BackgroundLevel0;
export const StickyFooterStuckBoxShadow = Overlay2;
